module.exports = __webpack_public_path__ + "img/home.88a98d5f.svg";